import styled from 'styled-components';
import { WindowProps } from './props/WindowProps';
import { WindowStyleProps } from './props/WindowStyleProps';

export const Window = () => {
  return (
    <>
      <Title>Window</Title>

      <WindowProps />
      <WindowStyleProps />
    </>
  );
};

const Title = styled.h1`
  position: sticky;
  top: 0;
  z-index: 1;

  background-color: var(--panel-bg-color-secondary);
`;
